import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { get } from "lodash";
import { Field } from "redux-form";

import { FormField } from "../../../../sharedComponents/formField";
import KeywordSearch from "../../../../sharedComponents/keywordSearch";
import { getImages } from "../../../../store/actions";
import Loader from "../../../../sharedComponents/preloader";

const ImagesGallery = ({
	toggleAddImagePanel,
	getImages,
	imageList,
	imageListNext,
	recipeImages,
	addToRecipeImages,
	atBottom,
	setAtBottom
}) => {
	const [stateImageList, updateStateImageList] = useState([]);
	const [selectedImageList, setSelectedImageList] = useState([]);

	useEffect(() => {
		getImages("limit=30&offset=0");
	}, [getImages]);

	useEffect(() => {
		updateStateImageList((prevState) => [...prevState, ...imageList]);
		setAtBottom(false);
	}, [imageList, setAtBottom]);

	useEffect(() => {
		if (atBottom && imageListNext) {
			getImages(imageListNext.split("?")[1]);
		}
	}, [atBottom, getImages, imageListNext]);

	const addToSelectedImageList = (event, item) => {
		const selectedImage = stateImageList.filter((i) => i.id === item.id)[0];
		event
			? setSelectedImageList((prevState) => [
					...prevState,
					{
						...selectedImage,
						id: null,
						image_data: {
							id: selectedImage.id,
							name: selectedImage.name,
							photo_l: selectedImage.photo_l,
							photo_m: selectedImage.photo_m,
							photo_o: selectedImage.photo_o,
							photo_s: selectedImage.photo_s,
							source: selectedImage.source
						},
						isNew: true
					}
			  ])
			: setSelectedImageList(selectedImageList.filter((i) => i.id !== item.id));
	};

	const addToRecipeImageListNow = () => {
		addToRecipeImages(selectedImageList);
		setSelectedImageList([]);
		toggleAddImagePanel(false);
	};

	return (
		<div className="panel-tab-content">
			<div className="flex-fill pb-5">
				<div className="row mt-3">
					<div className="col-8 pt-3">
						<KeywordSearch
							placeholder="Search Images"
							searchField="name"
							searchAction={getImages}
							onResetField={() => updateStateImageList([])}
							listName="AddRecipe.imageList"
							name="searchImage"
						/>
					</div>
				</div>
				<div className="row p-2">
					{stateImageList.map(({ id, photo_m }, index) => {
						const isSelectedImage = recipeImages.filter((item) => item.image_data.id === id).length > 0;
						return (
							<div key={index} className="col-3 p-2">
								<div className="card card-default h-100">
									<Field
										name={`selectedImage_${id}`}
										type="thumbnail"
										options={{ id, image: photo_m }}
										formGroupClass="select-thumbnail"
										component={FormField}
										onSelect={addToSelectedImageList}
										disabled={isSelectedImage}
									/>
								</div>
							</div>
						);
					})}
				</div>
				{atBottom ? <Loader /> : null}
			</div>
			<div className="pt-4 pb-4 sticky-footer">
				<div className="text-right">
					<button className="btn btn-default" type="button" onClick={() => toggleAddImagePanel(false)}>
						Cancel
					</button>
					<button className="btn btn-primary-dark" type="button" onClick={addToRecipeImageListNow}>
						Add Image
					</button>
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
	return {
		imageList: get(state.AddRecipe, "imageList.results", []),
		imageListNext: get(state.AddRecipe, "imageList.next", null)
	};
};

const mapDispatchToProps = {
	getImages
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(ImagesGallery);
